import {translate} from 'vue-gettext'

const {pgettext: $pgettext} = translate

export const TOOLTIP_COLOR = '#A9A8C2'
export const tooltipEventWizard = {
    mediaKit: {
        content: () => $pgettext('overview.tooltip', 'Send this link via email, whatsapp or text message and guests will be able to access their photos in just one click.'),
        placement: 'top',
        color: TOOLTIP_COLOR,
    },
    qrCode: {
        content: () => $pgettext('overview.tooltip', 'Display the QR code and guests will be able to access their photos by scanning it.'),
        placement: 'top',
        color: TOOLTIP_COLOR,
    },
    galleryUpload: {
        content: () => $pgettext('overview.tooltip', 'Select the folder and upload all the photos of the event.'),
        placement: 'top',
        color: TOOLTIP_COLOR,
    },
    galleryPricelist: {
        content: () => $pgettext('overview.tooltip', 'Set your price list to sell your photos'),
        placement: 'top',
        color: TOOLTIP_COLOR,
    },
    planOptionsSelector: {
        content: () => $pgettext('plan.tooltip', 'The photos will be available on our servers for two years, except in cases of early deletion request.'),
        placement: 'top',
        color: TOOLTIP_COLOR,
    },
    eventActivation: {
      content: () => $pgettext('event.tooltip', 'Once activated, the event cannot be suspended or deleted.'),
      placement: 'right',
      color: TOOLTIP_COLOR,
    }
}





